import { ISalad } from '../../../../models/ISalad';
import { IFormSchema } from '../../../../models/ISchema';

export const fieldSchema: IFormSchema<Pick<ISalad, 'name' | 'description' | 'isActive'>> = {
  name: {
    initialValue: '',
    rules: {
      required: true,
      maxLength: 48,
      minLength: 3,
    },
  },
  description: {
    initialValue: '',
  },
  isActive: {
    initialValue: true,
  },
};
